export default "__VITE_ASSET__TNp_ocXj__"